(() => {
  if (window.__ELOOKUS_OFFERS_CENTER__) return;
  window.__ELOOKUS_OFFERS_CENTER__ = true;

  const WELCOME_CODE = 'WELCOME10';
  const PENDING_KEY = 'elookus_pending_offer';
  const PENDING_EMAIL_KEY = 'elookus_pending_offer_email';
  const SELECTED_KEY = 'elookus_selected_offer';
  const CLAIMED_KEY = 'elookus_welcome_claimed';
  const CLAIMED_EMAIL_KEY = 'elookus_welcome_email';
  const RETURN_KEY = 'elookus_welcome_return';

  const sessionGet = (key) => {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  };
  const sessionSet = (key, value) => {
    try { window.sessionStorage.setItem(key, value); } catch (error) {}
  };
  const sessionRemove = (key) => {
    try { window.sessionStorage.removeItem(key); } catch (error) {}
  };
  const localGet = (key) => {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  };
  const localSet = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (error) {}
  };

  const panels = () => Array.from(document.querySelectorAll('[data-elookus-offers-panel]'));

  const serverAppliedCode = () => {
    const applied = document.querySelector('[data-elookus-offer-code][data-server-applied="true"]');
    return applied ? applied.dataset.elookusOfferCode : null;
  };

  const selectedCode = () => serverAppliedCode() || sessionGet(SELECTED_KEY);
  const claimedEmail = () => String(localGet(CLAIMED_EMAIL_KEY) || '').trim();
  const claimedWelcome = () => localGet(CLAIMED_KEY) === '1' || Boolean(claimedEmail());

  const markWelcomeClaimed = (email) => {
    const cleanEmail = String(email || '').trim();
    localSet(CLAIMED_KEY, '1');
    if (cleanEmail) localSet(CLAIMED_EMAIL_KEY, cleanEmail);
  };

  const getWelcomeState = () => {
    const panel = panels()[0];
    const state = panel || document.querySelector('[data-elookus-welcome-auth-state]');
    if (!state) {
      return {
        loggedIn: false,
        eligible: true,
        acceptsMarketing: false,
        claimed: claimedWelcome(),
        unlocked: claimedWelcome(),
        email: claimedEmail(),
      };
    }

    const loggedIn = state.dataset.welcomeServerVerified === 'true' || state.dataset.loggedIn === 'true';
    const eligible = state.dataset.welcomeEligible !== 'false' && state.dataset.eligible !== 'false';
    const acceptsMarketing = state.dataset.welcomeAcceptsMarketing === 'true' || state.dataset.acceptsMarketing === 'true';
    const serverEmail = String(state.dataset.welcomeEmail || state.dataset.email || '').trim();
    const email = serverEmail || claimedEmail();
    const claimed = acceptsMarketing || claimedWelcome();
    return { loggedIn, eligible, acceptsMarketing, claimed, unlocked: eligible && claimed, email };
  };

  const syncUi = () => {
    const selected = selectedCode();
    const applied = serverAppliedCode();
    const state = getWelcomeState();

    document.querySelectorAll('[data-elookus-offers-trigger-status]').forEach((status) => {
      status.textContent = applied ? '1 applied' : (selected ? '1 selected' : '');
    });

    document.querySelectorAll('[data-elookus-offer-card]').forEach((card) => {
      const code = card.dataset.elookusOfferCode;
      const button = card.querySelector('[data-elookus-offer-apply], [data-elookus-welcome-reveal]');
      const message = card.querySelector('[data-elookus-offer-message]');
      if (!button) return;

      if (code === WELCOME_CODE && message) {
        if (!state.eligible) {
          message.textContent = 'This first-order offer is not available on returning-customer accounts.';
        } else if (card.dataset.serverApplied === 'true') {
          message.textContent = 'Applied to this order.';
        } else if (selected === code || state.unlocked) {
          message.textContent = 'Email saved. Use the same email at checkout.';
        } else {
          message.textContent = 'New customers only. Enter an email you can access to unlock this offer.';
        }
      }

      if (button.disabled) return;
      button.classList.remove('is-applied');

      if (card.dataset.serverApplied === 'true') {
        button.textContent = 'Applied';
        button.classList.add('is-applied');
      } else if (selected === code) {
        button.textContent = 'Selected';
        button.classList.add('is-applied');
      } else if (code === WELCOME_CODE && state.unlocked) {
        button.textContent = 'Apply';
      } else {
        button.textContent = button.dataset.defaultLabel || 'Unlock & Apply';
      }
    });
  };

  const closePanel = (panel) => {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('elookus-offers-open');
    document.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
  };

  const openPanel = (panel) => {
    if (!panel) return;
    syncUi();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('elookus-offers-open');
    document.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    const close = panel.querySelector('.elookus-offers-drawer__close');
    if (close) setTimeout(() => close.focus(), 0);
  };

  const beginWelcomeFlow = (returnTo, email) => {
    sessionSet(PENDING_KEY, WELCOME_CODE);
    sessionRemove(SELECTED_KEY);
    if (returnTo) sessionSet(RETURN_KEY, returnTo);
    if (email) sessionSet(PENDING_EMAIL_KEY, email);
  };

  const resetWelcomeFlow = () => {
    sessionRemove(PENDING_KEY);
    sessionRemove(PENDING_EMAIL_KEY);
    sessionRemove(RETURN_KEY);
  };

  const applyGenericCode = (code, redirect) => {
    const cleanCode = String(code || '').trim();
    if (!cleanCode) return;
    sessionSet(SELECTED_KEY, cleanCode);
    const destination = redirect || '/cart';
    window.location.assign(`/discount/${encodeURIComponent(cleanCode)}?redirect=${encodeURIComponent(destination)}`);
  };

  const showWelcomeForm = (card) => {
    if (!card) return;
    const wrapper = card.querySelector('[data-elookus-welcome-email-form-wrap]');
    const trigger = card.querySelector('[data-elookus-welcome-reveal]');
    if (!wrapper) return;
    wrapper.hidden = false;
    if (trigger) trigger.hidden = true;
    const input = wrapper.querySelector('input[type="email"]');
    if (input) setTimeout(() => input.focus(), 0);
  };

  const handleWelcomeAction = (panel, card) => {
    const state = getWelcomeState();
    if (!state.eligible) return;
    if (state.unlocked) {
      applyGenericCode(WELCOME_CODE, (panel && panel.dataset.cartRedirect) || '/cart');
      return;
    }
    showWelcomeForm(card);
  };

  document.addEventListener('submit', (event) => {
    const wrapper = event.target.closest('[data-elookus-welcome-email-form-wrap]');
    if (!wrapper) return;
    const panel = wrapper.closest('[data-elookus-offers-panel]');
    const input = wrapper.querySelector('input[type="email"]');
    const email = String(input?.value || '').trim();
    const returnTo = panel ? (panel.dataset.cartRedirect || '/cart') : `${window.location.pathname}${window.location.search}`;
    beginWelcomeFlow(returnTo, email);
  });

  document.addEventListener('click', (event) => {
    const direct = event.target.closest('[data-elookus-welcome-direct]');
    if (direct) {
      event.preventDefault();
      const state = getWelcomeState();
      if (!state.eligible) return;
      if (state.acceptsMarketing) markWelcomeClaimed(state.email);
      applyGenericCode(WELCOME_CODE, '/cart');
      return;
    }

    const checkout = event.target.closest('button[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (checkout) {
      const selected = selectedCode();
      if (selected && !serverAppliedCode()) {
        event.preventDefault();
        applyGenericCode(selected, '/checkout');
        return;
      }
    }

    const openButton = event.target.closest('[data-elookus-offers-open]');
    if (openButton) {
      event.preventDefault();
      openPanel(document.getElementById(openButton.getAttribute('aria-controls')));
      return;
    }

    const closeButton = event.target.closest('[data-elookus-offers-close]');
    if (closeButton) {
      event.preventDefault();
      closePanel(closeButton.closest('[data-elookus-offers-panel]'));
      return;
    }

    const reveal = event.target.closest('[data-elookus-welcome-reveal]');
    if (reveal) {
      event.preventDefault();
      const card = reveal.closest('[data-elookus-offer-card]');
      const panel = reveal.closest('[data-elookus-offers-panel]');
      handleWelcomeAction(panel, card);
      return;
    }

    const applyButton = event.target.closest('[data-elookus-offer-apply]');
    if (applyButton) {
      event.preventDefault();
      const card = applyButton.closest('[data-elookus-offer-card]');
      const panel = applyButton.closest('[data-elookus-offers-panel]');
      if (!card || !panel) return;
      const code = String(card.dataset.elookusOfferCode || '').trim();
      if (code.toUpperCase() === WELCOME_CODE) handleWelcomeAction(panel, card);
      else applyGenericCode(code, panel.dataset.cartRedirect || '/cart');
      return;
    }

    const manualToggle = event.target.closest('[data-elookus-manual-toggle]');
    if (manualToggle) {
      event.preventDefault();
      const wrapper = manualToggle.closest('.elookus-manual-code');
      const fields = wrapper && wrapper.querySelector('[data-elookus-manual-fields]');
      if (!fields) return;
      const willOpen = fields.hidden;
      fields.hidden = !willOpen;
      manualToggle.setAttribute('aria-expanded', String(willOpen));
      const symbol = manualToggle.querySelector('span');
      if (symbol) symbol.textContent = willOpen ? '−' : '+';
      if (willOpen) {
        const input = fields.querySelector('[data-elookus-manual-code]');
        if (input) input.focus();
      }
      return;
    }

    const manualApply = event.target.closest('[data-elookus-manual-apply]');
    if (manualApply) {
      event.preventDefault();
      const panel = manualApply.closest('[data-elookus-offers-panel]');
      const input = panel && panel.querySelector('[data-elookus-manual-code]');
      if (!panel || !input || !input.value.trim()) return;
      applyGenericCode(input.value.trim(), panel.dataset.cartRedirect || '/cart');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-elookus-offers-panel].is-open');
    if (open) closePanel(open);
  });

  const init = () => {
    const state = getWelcomeState();
    const applied = serverAppliedCode();
    const success = document.querySelector('[data-elookus-welcome-signup-success]');
    const error = document.querySelector('[data-elookus-welcome-signup-error]');

    if (state.acceptsMarketing) markWelcomeClaimed(state.email);

    if (applied === WELCOME_CODE) {
      markWelcomeClaimed(state.email || sessionGet(PENDING_EMAIL_KEY));
      sessionRemove(SELECTED_KEY);
      resetWelcomeFlow();
      syncUi();
      return;
    }

    if (success) {
      const pendingEmail = sessionGet(PENDING_EMAIL_KEY);
      markWelcomeClaimed(pendingEmail || state.email);
      const destination = sessionGet(RETURN_KEY) || '/cart';
      resetWelcomeFlow();
      setTimeout(() => applyGenericCode(WELCOME_CODE, destination), 350);
      return;
    }

    if (error) {
      const panel = panels()[0];
      if (panel) {
        openPanel(panel);
        const card = panel.querySelector('[data-elookus-offer-code="WELCOME10"]');
        showWelcomeForm(card);
      }
      return;
    }

    if (sessionGet(PENDING_KEY) === WELCOME_CODE && getWelcomeState().unlocked) {
      const destination = sessionGet(RETURN_KEY) || '/cart';
      resetWelcomeFlow();
      setTimeout(() => applyGenericCode(WELCOME_CODE, destination), 250);
      return;
    }

    syncUi();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
